'use client';
import type { HTMLAttributes } from 'react';

import Image from 'next/image';

export type Flag = 'vn' | 'us';

interface FlagIconProps extends HTMLAttributes<HTMLSpanElement> {
    code: Flag;
    width?: number;
    height?: number;
}

export default function FlagIcon({
    code,
    width = 32,
    height = 24,
    ...rest
}: FlagIconProps) {
    const src =
        code === 'vn'
            ? '/images/illustrations/flag/vn.png'
            : '/images/illustrations/flag/us.png';

    const alt = code === 'vn' ? 'Vietnam flag' : 'United States flag';

    return (
        <span {...rest} style={{ display: 'inline-flex', lineHeight: 0 }}>
            <Image src={src} alt={alt} width={width} height={height} priority />
        </span>
    );
}
